<template>
    <div class="container basket mt-2">
        <div class="row">
            <div class="col">
                <template v-for="(item, index) in items">
                    <cart-item :item="item"></cart-item>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    methods: {
    },
    computed: {
        items() {
            return this.$store.state.cart.items;
        },
    },
};
</script>
